export default __webpack_public_path__ + "static/media/logo.713b6c00.png";